import React from 'react';
import { Helmet } from 'react-helmet';

const content_string =
  "Building renewable systems, exploring sustainability concepts, socializing with new friends.";

const CustomHelmet = ({image_logo}) => (
    <>
      <Helmet>
        <title>RED Club @UAlberta</title>
        <meta name="description" content={content_string} />
        <meta property="og:title" content="RED Club @UAlberta" />
        <meta property="og:description" content={content_string} />
        <meta property="og:image" content={image_logo} />
        <link rel="shortcut icon" href={image_logo} type="image/x-icon" />
        <link rel="apple-touch-icon" href={image_logo} />
        <link rel="apple-touch-icon" sizes="76x76" href={image_logo} />
        <link rel="apple-touch-icon" sizes="152x152" href={image_logo} />
        <link rel="apple-touch-startup-image" href={image_logo} />
        <meta name="msapplication-TileImage" content={image_logo} />
        <meta name="msapplication-TileColor" content="#232323" />
      </Helmet>
    </>
  );
  
  export default CustomHelmet;